import React from "react";
import { Link } from "react-router-dom";
import { resolveImageUrl } from "../../../utils";

const ExitGoodsPermitSection: React.FC = () => {
  return (
    <div className="relative rounded-2xl bg-white p-5 shadow-sm ring-1 ring-gray-200 overflow-hidden dark:bg-gray-900 dark:ring-gray-700 min-h-44 pb-8">
      
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-base font-semibold text-gray-900 dark:text-white">
          Exit Goods Permit
        </h3>
        <Link 
          to="/" 
          className="text-xs font-medium text-gray-500 hover:text-gray-700 dark:text-white flex items-center gap-1"
        >
          View all <span>{"\u203A"}</span>
        </Link>
      </div>

      
      <div className="relative z-10 pr-20">
        <div className="grid grid-cols-3 gap-x-4 gap-y-4">
          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-gray-200 bg-gray-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-gray-600 dark:text-gray-400" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Waiting TR
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>

          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-blue-100 bg-blue-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="2" fill="currentColor"/>
                <circle cx="5" cy="12" r="1.5" fill="currentColor"/>
                <circle cx="19" cy="12" r="1.5" fill="currentColor"/>
                <circle cx="12" cy="5" r="1.5" fill="currentColor"/>
                <circle cx="12" cy="19" r="1.5" fill="currentColor"/>
                <circle cx="7" cy="7" r="1" fill="currentColor"/>
                <circle cx="17" cy="7" r="1" fill="currentColor"/>
                <circle cx="7" cy="17" r="1" fill="currentColor"/>
                <circle cx="17" cy="17" r="1" fill="currentColor"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Waiting OPS
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>

          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-blue-100 bg-blue-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" viewBox="0 0 24 24" fill="none">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Approved
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>

          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-blue-100 bg-blue-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" strokeWidth="2"/>
                <line x1="9" y1="3" x2="9" y2="21" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Check In
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>

          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-blue-100 bg-blue-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Done
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>

          
          <div className="flex flex-col items-center text-center gap-1">
            <div className="w-10 h-10 rounded-lg border border-blue-100 bg-blue-50 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center flex-shrink-0">
              <svg className="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
                <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight line-clamp-2">
                Reject
              </p>
              <p className="text-base font-bold text-gray-900 dark:text-white leading-tight mt-0.5">
                0
              </p>
            </div>
          </div>
        </div>
      </div>

      
      <div className="absolute bottom-2 right-2 w-28 h-28 pointer-events-none opacity-40 sm:opacity-100">
        <img 
          src={resolveImageUrl("/images/icon (10).png")} 
          alt="Exit Goods" 
          className="w-full h-full object-contain"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
};

export default ExitGoodsPermitSection;